
import { api_host,api_auth} from '../../common/globals/constants';


export const feedback = (user, stars, usefull, improvement, desc, token) => fetch(api_host+`/reporte/online/indicadores/feeedBack/?user=${user}&token=${token}&stars=${stars}&usefull=${usefull}&improvement=${improvement}&desc=${desc}`)
.then(response => response.json())
